import React from 'react';
import useTranslation from 'next-translate/useTranslation';

import { Refresh } from '@/icons/index';

import Button from '../Button/Button';
import Select from '../Select/Select';
import OwnPhoneInput from '../OwnPhoneInput/OwnPhoneInput';
import { YourNumberList, TextBlock } from '../index';

import styles from './CreateOwnPhoneInput.module.scss';

const CreateOwnPhoneInput = ({
  value = [],
  onChange,
  sortValue,
  onSelect,
  sortData,
  onSubmit,
  tabs,
  loadMore,
  data,
  isLoading,
  totalPage,
  detail,
  resetFields,
  isEsim = true,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={styles.container}
      itemScope
      itemType='http://schema.org/CreativeWork'
    >
      <div className={styles.sortContainer}>
        <div className={styles.sortInput}>
          <Select
            className={styles.select}
            value={sortValue}
            data={sortData}
            onChange={(e) => onSelect(e)}
          />
        </div>
        <OwnPhoneInput
          inputClass={styles.search_input_number}
          value={value}
          onChange={(val) => onChange(val)}
        />
        <div className={styles.buttons}>
          <Button data-testid={'numbersale-submit'} onClick={onSubmit}>
            {detail?.search_button_text ?? t('common:Search')}
          </Button>
          <Button
            data-testid={'numbersale-refresh'}
            className={styles.refresh}
            onClick={resetFields}
          >
            <Refresh />
          </Button>
        </div>
      </div>

      <div>
        {data?.length > 0 ? (
          <YourNumberList
            titles
            tabs={tabs ?? []}
            list={data}
            loadMore={loadMore}
            isLoading={isLoading}
            totalPage={totalPage}
            detail={detail}
            isEsim={isEsim}
          />
        ) : (
          <TextBlock className={'text--large no-data'}>
            {t('esim:common.numberNotFound')}
          </TextBlock>
        )}
      </div>
    </div>
  );
};

export default CreateOwnPhoneInput;
